import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { finalize, mergeMap, retryWhen, tap } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(private readonly http: HttpClient) {}

  public load(): Promise<void> {
    return this.http
      .get<any>(environment.api.app)
      .pipe(
        retryWhen(genericRetryStrategy({ maxRetryAttempts: 10, excludedStatusCodes: [500, 504] })),
        tap((res) => (environment.api.version = res.version)),
      )
      .toPromise();
  }
}

export const StartupServiceFactory: (startup: StartupService) => () => Promise<void> =
  (startup: StartupService): (() => Promise<void>) =>
  () =>
    startup.load();

export const StartupServiceFactoryProvider = {
  provide: APP_INITIALIZER,
  useFactory: StartupServiceFactory,
  deps: [StartupService],
  multi: true,
};

export const genericRetryStrategy =
  ({
    maxRetryAttempts = 3,
    scalingDuration = 1000,
    excludedStatusCodes = [],
  }: {
    maxRetryAttempts?: number;
    scalingDuration?: number;
    excludedStatusCodes?: number[];
  } = {}) =>
  (attempts: Observable<any>) => {
    return attempts.pipe(
      mergeMap((error, i) => {
        const retryAttempt = i + 1;
        // if maximum number of retries have been met
        // or response is a status code we don't wish to retry, throw error
        if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find((e) => e === error.status)) {
          return throwError(error);
        }
        return timer(retryAttempt * scalingDuration);
      }),
      finalize(() => {}),
    );
  };
